// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__aelc6","panelContent":"Panel_panelContent__lRk5E","panelHeader":"Panel_panelHeader__58YB_","title":"Panel_title__kfBf3","colored":"Panel_colored__AjbTC"};